export default __webpack_public_path__ + "static/media/stepper.9f9e96db.svg";